import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FullLayoutComponent } from './containers/full-layout/full-layout.component';
import { AuthGuard } from './core/services/auth/auth.guard';
import { ResolverService } from './core';
import { ConditionsGuard } from './core/services/conditions/conditions.guard';
import { TwoFactorAuthenticationGuard } from './core/services/two-factor-authentication/two-factor-authentication.guard';
import { LogResolverService } from './core';
import { CustomersInvoicePrintComponent } from './modules/customers/components/customers-invoice-print/customers-invoice-print.component';
import { SalesPrintComponent } from './modules/reports/components/sales-print/sales-print.component';
import { LandingComponent } from './shared/components/landing/landing.component';
import { PrintCatalogComponent } from './modules/gift-cards/components/print-catalog/print-catalog.component';
import { PrintProductTableComponent } from './modules/gift-cards/components/print-product-table/print-product-table.component';
import { CreateOnlinePaymentComponent } from './modules/online-payments/components/create-online-payment/create-online-payment.component';
import { InvoiceDetailComponent } from './modules/postpaid/components/invoice-detail/invoice-detail.component';
import { AccessoryOrderDetailComponent } from './modules/gift-cards/components/accessory-order-detail/accessory-order-detail.component';

const routes = [
  {
    path: '', loadChildren: () =>
      import('./modules/login/login.module').then(mod => mod.LoginModule),
  },
  {
    path: 'landing',
    component: LandingComponent
  },
  {
    path: 'customers/invoice/print/:id',
    component: CustomersInvoicePrintComponent,
    resolve: [ResolverService],
    canActivate: [AuthGuard, ConditionsGuard, TwoFactorAuthenticationGuard],
  },
  {
    path: 'postpaid/invoices/print/:id',
    component: InvoiceDetailComponent,
    resolve: [ResolverService],
    canActivate: [AuthGuard, ConditionsGuard, TwoFactorAuthenticationGuard],
  },
  {
    path: 'gifts/accessory/orders/:id',
    component: AccessoryOrderDetailComponent,
    resolve: [ResolverService],
    canActivate: [AuthGuard, ConditionsGuard, TwoFactorAuthenticationGuard],
  },
  {
    path: 'reports/sales/print',
    component: SalesPrintComponent,
    resolve: [ResolverService],
    canActivate: [AuthGuard, ConditionsGuard, TwoFactorAuthenticationGuard],
  },
  {
    path: 'catalog/:id', component: PrintCatalogComponent
  },
  {
    path: 'catalog-list', component: PrintProductTableComponent
  },
  {
    path: 'financial-payment',
    component: CreateOnlinePaymentComponent,
    resolve: [ResolverService],
  },
  {
    path: '',
    children: [{
      path: '', component: FullLayoutComponent,
      // resolve: [LogResolverService],
      children: [
        {
          path: 'postpaid',
          loadChildren: () => import('./modules/postpaid/postpaid.module').then(mod => mod.PostpaidModule)
        },
        {
          path: 'dashboard', loadChildren: () =>
            import('./modules/dashboard/dashboard.module').then(mod => mod.DashboardModule)
        },

        {
          path: 'egifts', loadChildren: () =>
            import('./modules/e-gift-cards/e-gift-cards.module').then(mod => mod.EGiftCardsModule)
        },

        {
          path: 'gifts', loadChildren: () =>
            import('./modules/gift-cards/gift-cards.module').then(mod => mod.GiftCardsModule)
        },

        {
          path: 'reports', loadChildren: () =>
            import('./modules/reports/reports.module').then(mod => mod.ReportsModule)
        },

        {
          path: 'customers', loadChildren: () =>
            import('./modules/customers/customers.module').then(mod => mod.CustomersModule)
        },

        {
          path: 'user', loadChildren: () =>
            import('./modules/customers/customers.module').then(mod => mod.CustomersModule)
        },

        {
          path: 'finance', loadChildren: () =>
            import('./modules/finance/finance.module').then(mod => mod.FinanceModule)
        },

        {
          path: 'basket', loadChildren: () =>
            import('./modules/basket/basket.module').then(mod => mod.BasketModule)
        },

        {
          path: 'support', loadChildren: () =>
            import('./modules/support/support.module').then(mod => mod.SupportModule)
        },

        {
          path: 'online-payments', loadChildren: () =>
            import('./modules/online-payments/online-payments.module').then(mod => mod.OnlinePaymentsModule)
        },

        // {
        //   path: 'crypto-currency', loadChildren: () =>
        //     import('./modules/cryptocurrency/cryptocurrency.module').then(mod => mod.CryptocurrencyModule)
        // },
        {
          path: 'notifications',
          loadChildren: () => import('./modules/notification/notification.module').then(mod => mod.NotificationModule)
        },
        {
          path:'bulk-digital-orders',
          loadChildren: ()=> import('./modules/bulk-digital-orders/bulk-digital-orders.module').then(mod => mod.BulkDigitalOrdersModule)
        }
      ]
    }],
    resolve: [ResolverService],
    canActivate: [AuthGuard, ConditionsGuard, TwoFactorAuthenticationGuard],
  },
  { path: '**', redirectTo: '' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }










